export const MapApiKey = '83841bdc-892a-431f-a9ff-b378ef38c6a0'
